module.exports = __webpack_public_path__ + "media/images/homes/quick_service-b3aca5bd4ecc29f6b2a7f8f2ade20443.png";